import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const AdPrice = {
  List: lazyNamed(() => import('./containers/AdPriceListPage/index.tsx'), 'AdPrices'),
  Edit: lazyNamed(() => import('./containers/AdPriceFormPage/index.tsx'), 'AdPriceFormPage'),
  History: lazyNamed(() => import('./containers/AdPriceHistory.tsx'), 'AdPriceHistory'),
};
